/**
 * @desc 根据实例id获取任务list
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.BpmActivitiTaskInfoDto>>;
export function request(
  instId: string | number,
  params: API.activiti.bpmApprovaTask.getTaskInfoByInstId.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/getTaskInfo/${instId}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
